type FormatCurrencyOptions = {
  locale?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
};

export const formatCurrency = (value: number, options: FormatCurrencyOptions = {}): string => {
  const { locale = 'en-US', minimumFractionDigits = 2, maximumFractionDigits = 2 } = options;

  return value.toLocaleString(locale, {
    minimumFractionDigits,
    maximumFractionDigits,
  });
};

export const formatCurrencyNegative = (
  value: number,
  options: FormatCurrencyOptions = {},
): string => {
  return formatCurrency(-Math.abs(value), options);
};
